import './App.css';

import { Routes, Route, useNavigate } from 'react-router-dom';

import ProtectedRoute from './components/auth/ProtectedRoute';
import { onLogin, onLogout } from './utils/trackingUtils';
import { useAuth } from './components/auth/authHelpers';
import LoginController from './components/auth/LoginController';
import Dashboard from './Dashboard';
import Health from './components/Admin/Health';

function App({ appName }: {appName: string}): React.JSX.Element {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  const handleAuthSuccess = (redirectTo: string): void => {
    const userId = currentUser?.userId || currentUser?.username || '';
    onLogin(userId);
    navigate(redirectTo || '/');
  };

  const handleLogout = (): void => {
    onLogout();
    navigate('/login');
  };

  return (
    <Routes>
      <Route path="/login" element={
        <LoginController
          appName={appName}
          onAuthSuccess={handleAuthSuccess}/>
      } />
      <Route path="/health" element={<Health />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard onLogout={handleLogout}/>
          </ProtectedRoute>
        }
      />
      {/* Add more protected routes as needed */}
    </Routes>
  );

};

export default App;
